export enum DataBuilderZones {
	facts = 'facts',
	rows = 'rows',
	columns = 'columns',
	filters = 'filters',
	drills = 'drills',
}
